    <template>
            <div>
                <section class="flex items-center justify-center h-screen col-md-8">
                            <div class="mx-auto flex w-full justify-around items-center">
                              <ul>
                                <li>
                                <div class="bt font-montserrat w-full text-black mx-5 z-10">
                                    <!-- <h1 class="text-4xl mb-10 font-raleway">Search for whatsoever recipe you want</h1> -->
                                    <b-button  class="bg-green-500 text-white font-bold py-1 px-4 rounded-full" @click="createCourseAgain">
                                        WEITEREN KURS ERSTELLEN
                                         <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" /> 
                                    </b-button>
                                </div>
                                </li>
                                <br>
                                <div class="field has-addons">
                                    <!-- <div class="content has-text-centered" style="width:100%">
                                        <strong class="text-xl text-gray-900 content has-text-centered">{{ course.courseCode }}</strong>
                                    </div> -->
                                </div>
                                <br>
                                <li>
                                <div class="bt mx-auto flex  w-full justify-center items-center">
                                  <div class="font-montserrat w-full text-black mx-5 z-10">
                                    <b-button  class="bg-green-500 text-white font-bold py-1 px-4 rounded-full" @click="goBack">
                                        ZURÜCK ZUR ÜBERSICHT DER KURSE
                                         <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" /> 
                                    </b-button>
                                    </div>
                                </div>
                                </li>
                              </ul>
                              <!-- <div>
                                <b-taglist>
                                    <b-tag type="is-info" size="is-medium">First</b-tag>
                                    <b-tag type="is-info" size="is-medium">Second</b-tag>
                                    <b-tag type="is-info" size="is-medium">Third</b-tag>
                                    <b-tag type="is-info" size="is-medium">Fourth</b-tag>
                                    <b-tag type="is-info" size="is-medium">Fifth</b-tag>
                                </b-taglist>
                              </div> -->
                                <!-- <div v-if="loading" class="rounded-full absolute bottom-20 bg-blue-300 w-10 h-10">
                                </div> -->

                            </div>
                        
                   
                    
                </section>
            
            </div>
        </template>

        <script>

            export default {
                name: "NewCourseChoice",
                components:{
                },
                methods: {
                       async goBack(e) {
                        e.preventDefault()
                        try{
                              this.$router.push("/instructor-courses");
                              location.reload(this.$router.currentRoute);
                        }catch(error){
                            this.error = true
                        }
                },
                async createCourseAgain(e) {
                    e.preventDefault()
                        try{
                              this.$router.push("/new-course");
                              location.reload(this.$router.currentRoute);
                        }catch(error){
                            this.error = true
                        }
                }
                
            }
            }
        </script>
        <style scoped>
        </style>